import React, { useState } from "react";
import TextField from "@material-ui/core/TextField";
import isNullOrEmpty from "~libs/isNullOrEmpty";

const TelefonoField = ({
  required,
  displayError,
  onChange,
  value,
  optional
}) => {
  const [errorText, setErrorText] = useState("Requerido");
  const [valid, setValid] = useState(false);
  const [touched, setTouched] = useState(false);

  const handleChange = event => {
    const validation = validateTelefono(event.target.value, required);

    setTouched(false);
    setValid(validation.valid);
    setErrorText(validation.error);

    if (onChange)
      onChange({
        target: {
          value: {
            value: event.target.value,
            valid: validation.valid
          }
        }
      });
  };

  const handleBlur = () => {
    const validation = validateTelefono(value, required);

    setTouched(true);
    setValid(validation.valid);
    setErrorText(validation.error);

    if (onChange)
      onChange({
        target: {
          value: {
            value: value,
            valid: validation.valid
          }
        }
      });
  };

  const showError = !valid && (displayError || touched) && !optional;

  return (
    <TextField
      onChange={handleChange}
      onBlur={handleBlur}
      value={value}
      helperText={showError ? errorText : ""}
      error={showError}
      label={optional ? "Teléfono (opcional)" : "Teléfono"}
      type="tel"
      fullWidth
    />
  );
};

export default TelefonoField;

const validateTelefono = (value, isRequired) => {
  if (isNullOrEmpty(value) && isRequired)
    return { valid: false, error: "Requerido" };

  return { valid: true, error: "" };
};
